import UnitelModal from 'components/Modal/UnitelModal'
import { mobilePageTitleAtom } from 'config/store'
import { getUserInfoQuery } from 'dataLayer/game'
import { useUpdateUserInfo } from 'dataLayer/user'
import { useAtom } from 'jotai'
import { useEffect, useRef, useState } from 'react'
import { Button, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { getUserinfo, saveUserInfo } from 'utils/localStorage'

function ChangeInfoMobile({ title }) {
	const { t } = useTranslation()

	const { data: userInfo } = useQuery(getUserInfoQuery())

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const prevInfoUser = useRef()
	useEffect(() => {
		prevInfoUser.current = infoData
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const [infoData, setInfoData] = useState({
		full_name: userInfo?.displayName,
		phone: userInfo?.msisdn,
	})
	function handleInfoChange(e) {
		const newInfoData = { ...infoData }
		newInfoData[e.target.id] = e.target.value
		setInfoData(newInfoData)
	}

	const {
		mutate,
		data: updateUserInfo,
		isLoading,
	} = useUpdateUserInfo(successUpdateInfoCb)
	function handleUpdateInfo() {
		mutate(infoData)
	}
	function successUpdateInfoCb() {
		const currentUser = getUserinfo()
		saveUserInfo({
			...currentUser,
			fullname: userInfo?.displayName,
			msisdn: userInfo?.msisdn,
		})
	}

	return (
		<>
			<Container fluid className="userinfo-mobile-container">
				<Row className="profilepage-content__body mobile my-3">
					<Form className="baseinput-container">
						<Form.Group className="mb-3 base-input personal-info">
							<Form.Label>{t('profile.personal_info.name')}</Form.Label>
							<Form.Control
								type="text"
								value={infoData?.full_name}
								onChange={handleInfoChange}
								id="full_name"
							/>
						</Form.Group>
						<Form.Group className="mb-3 base-input personal-info">
							<Form.Label>{t('profile.personal_info.phone')}</Form.Label>
							<Form.Control
								disabled={true}
								type="phone"
								value={infoData?.phone}
								onChange={handleInfoChange}
								id="phone"
							/>
						</Form.Group>
					</Form>
					<Button
						className="profile-confirm mobile"
						onClick={handleUpdateInfo}
						disabled={
							prevInfoUser.current?.full_name === infoData?.full_name &&
							prevInfoUser.current?.phone === infoData?.phone
						}
					>
						{t('confirm')}
						{isLoading ? (
							<Spinner animation="border" role="status"></Spinner>
						) : null}
					</Button>
				</Row>
			</Container>
			<UnitelModal data={updateUserInfo} />
		</>
	)
}

export default ChangeInfoMobile
